import React, { useState, useEffect, useCallback } from "react";
import { Col, Navbar } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import ReactCustomScrollbar from "../ReactCustomScrollbar";
import Header, { CollapsibleMenu } from "./Header";

const LeftMenuModern = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();

  const closeMenu = useCallback(() => {
    setShow(false);
    document.body.classList.remove("overflow-hidden");
    document.body.classList.remove("navbar-collapse-show");
    document.body.classList.remove("mobile-menu");
  }, []);

  const openMenu = () => setShow(true);

  useEffect(() => {
    closeMenu();
  }, [location.pathname, closeMenu]);

  useEffect(() => {
    const onEscape = (e) => {
      if (e.key === "Escape") closeMenu();
    };

    if (show) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    window.addEventListener("keydown", onEscape);
    return () => window.removeEventListener("keydown", onEscape);
  }, [show, closeMenu]);

  return (
    <>
      <Header
        topSpace={{ md: true }}
        className="left-menu-modern-sidebar fixed top-0 left-0 z-10 md:w-full md:h-auto"
      >
        <div className="bg-white sidebar-nav-action h-[100vh] md:h-auto w-[290px] md:w-full py-[30px] flex flex-col md:flex-row md:justify-between md:px-[30px] md:py-[10px] sm:px-[15px] overflow-visible">
          <Col className="flex items-center justify-center md:justify-start overflow-visible">
            <Link aria-label="header logo" to="/" onClick={closeMenu}>
              <img
                className="sidebar-logo"
                alt="Urban Brew logo"
                src="/UrbanBrew_Logo_Blue.png"
                width={160}
                height={48}
                decoding="async"
              />
            </Link>
          </Col>
          <Col className="flex-1 flex flex-col mt-8 px-3 items-center desktop-sidebar-menu">
            <CollapsibleMenu className="w-full" linkColor="#223bac" />
          </Col>
          <Col className="flex items-center justify-end mobile-hamburger">
            <Navbar className="inline-block" variant="dark">
              <Navbar.Toggle
                className="push-button"
                onClick={() => (show ? closeMenu() : openMenu())}
                aria-expanded={show}
                aria-label={show ? "Close menu" : "Open menu"}
              >
                <button aria-label="menu toggle" className="nav-icon" type="button">
                  <span className="navbar-toggler-line"></span>
                  <span className="navbar-toggler-line"></span>
                  <span className="navbar-toggler-line"></span>
                  <span className="navbar-toggler-line"></span>
                </button>
              </Navbar.Toggle>
            </Navbar>
          </Col>
          <div
            className={`mobile-menu-overlay${show ? " show" : ""}`}
            onClick={closeMenu}
            role="presentation"
          >
            <div
              className="mobile-menu-panel"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="mobile-menu-close"
                aria-label="Close menu"
                onClick={closeMenu}
              >
                <span />
                <span />
              </button>
              <ReactCustomScrollbar
                className="pl-[15px] pr-[15px] pb-[50px]"
                theme="light"
                autoHide
              >
                <CollapsibleMenu
                  className="w-full mx-auto xs:px-0"
                  linkColor="#223bac"
                  onNavigate={closeMenu}
                />
              </ReactCustomScrollbar>
            </div>
          </div>
          <Col className="flex flex-col justify-end items-center md:flex-row xs:hidden px-3">
            <div className="flex flex-col gap-4 items-center" />
          </Col>
        </div>
      </Header>
    </>
  );
};

export default LeftMenuModern;
